/**
 * Страница «Об авторе» (маршрут /about, И6). Отдельная, без шумной навигации:
 * кратко о проекте + блок донатов. Главная / не перегружается ссылкой сюда
 * (аккуратная «Об авторе» живёт в футере главной, см. App.tsx).
 *
 * Донаты (phase-2-plan §1/§2.6): реальный платёжный провайдер в Фазе 2 НЕ подключается
 * (без серверной обработки). Здесь — гибридный блок: внешняя ссылка-кнопка на
 * платёжную площадку (константа DONATE_URL, placeholder) + задокументированное место
 * под будущий встроенный виджет. Заменить DONATE_URL/встраивание — точка интеграции.
 */
import { useTranslation } from 'react-i18next';
import { Link } from '../components/ui';

/**
 * Placeholder внешнего доната. TODO(донаты): подставить реальный URL площадки
 * (Boosty / DonationAlerts / Ko-fi) либо встроить виджет. Серверной обработки нет.
 */
export const DONATE_URL = 'https://boosty.to/kikayoo';
export const TELEGRAM_URL = 'https://t.me/kikayO_o';

export function About(): JSX.Element {
  const { t } = useTranslation();
  return (
    <main className="card card--page" aria-labelledby="about-title">
      <Link to="/" className="back">
        {t('nav.back')}
      </Link>
      <p className="block-subtitle">{t('about.sectionLabel')}</p>
      <h1 id="about-title" className="page-title">
        kikayoo
      </h1>
      <p className="muted">{t('about.intro')}</p>

      <section className="telegram" aria-labelledby="telegram-title">
        <h2 id="telegram-title" className="block-title">
          {t('about.telegramTitle')}
        </h2>
        <p className="muted small">{t('about.telegramHint')}</p>
        <a
          className="cta telegram__btn"
          href={TELEGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('about.telegramLink')}
        </a>
      </section>

      <section className="donate" aria-labelledby="donate-title">
        <h2 id="donate-title" className="block-title">
          {t('about.donateTitle')}
        </h2>
        <p className="muted small">{t('about.donateHint')}</p>
        <a className="cta donate__btn" href={DONATE_URL} target="_blank" rel="noopener noreferrer">
          {t('about.donate')}
        </a>
        <p className="hint donate__note" data-testid="donate-note">
          {t('about.donateNote')}
        </p>
      </section>
    </main>
  );
}
